import type { Tutorial } from '@prisma/client';

export function useTutorials() {
  const getTutorials = async () => {
    const { data, error } = await useFetch<Tutorial[]>('/api/publicRoutes/tutorials', {
      method: 'GET'
    });

    return { data, error };
  };

  const getTutorialById = async (id: string) => {
    return await useFetch<Tutorial | undefined>(`/api/tutorials?id=${id}`, {
      method: 'GET'
    });
  };

  const createTutorial = async (tutorial: Tutorial) => {
    return await useFetch<Tutorial | undefined>('/api/tutorials', {
      method: 'POST',
      body: { tutorial }
    });
  };

  const updateTutorial = async (tutorial: Tutorial) => {
    return await useFetch<Tutorial | undefined>('/api/tutorials', {
      method: 'PUT',
      body: { tutorial }
    });
  };

  const deleteTutorial = async (id: string) => {
    return await useFetch('/api/tutorials', {
      method: 'DELETE',
      body: { id }
    });
  };

  return {
    getTutorials,
    getTutorialById,
    createTutorial,
    updateTutorial,
    deleteTutorial
  };
}
